jQuery($ => {
	if ($('.tabs').length) {
		$('.tabs').each(function() {
			let self = $(this);
			const tabActiveClass = 'tabs__tab--active';
			const contentActiveClass = 'tabs__content--active';

			self.find('.tabs__tab').click(function(e) {
				e.preventDefault();

				let tab = $(this).data('tab');

				self.find('.tabs__tab').removeClass(tabActiveClass);
				self.find('.tabs__content').removeClass(contentActiveClass);

				$(this).addClass(tabActiveClass);
				self.find('.tabs__content[data-tab="' + tab + '"]').addClass(
					contentActiveClass
				);

				//Accessibility consideration
				if($('#' + tab).length){
					let x = window.scrollX, y = window.scrollY;
					if(history.pushState) {
					    history.pushState(null, null, '#' + tab);
					}else {
					    window.location.hash = '#' + tab;
						setTimeout(function(){
							window.scrollTo(x, y);
						}, 0);
					}
				}
			});

			//open tab if it exists in the hash
			hash = location.hash;
			if(self.find('.tabs__tab[href="' + hash + '"]').length){
				self.find('.tabs__tab[href="' + hash + '"]').trigger('click');
			}
		});
	}
});
